<template>
    <div>
        PatientReviews
    </div>
</template>

<script>

export default{
    name:"PatientReviews"
}
</script>


// WEBPACK FOOTER //
// src/components/Users/Patient/PatientReviews.vue